// Axios
import axios from 'axios'
import gql from 'graphql-tag'

// GetAddress
export const GetAddress = (lat, lng) => new Promise((resolve, reject) => {
  axios.get(`${process.env.VUE_APP_MAP_URL}reverse?lat=${lat}&lon=${lng}&format=json`)
    .then((res) => {
      resolve(res)
    })
    .catch((err) => {
      reject(err)
    })
})

// GetAddressResult
export const GetAddressResult = async function (lat, lang) {
  const res = await GetAddress(lat, lang)

  return res.data.display_name
}

// GetAddressData
export const GetAddressData = async function (lat, lang) {
  const res = await GetAddress(lat, lang)

  return res.data
}

export const GET_ADDRESS = gql`
query Geofences {
  geofences {
    isSuccessful
    message
    geofences {
      data {
        geofenceId
        companyId
        customerId
        fenceName
        type
        polyData
        circData
        address
        addressDetail
        province
        city
        postalCode
        category
        contactName
        phoneNo
        isGarage
        isServiceLoc
        isBillingAddr
        isDepot
        isAlert
        serviceStart
        serviceEnd
        breakStart
        breakEnd
        serviceLocType
        customerName
        hasRelation
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
      }
    }
  }
}`
